export default __webpack_public_path__ + "static/media/firstOptionNDA.png?.61c9ac44";